/* LESIMO isolated activewear carousel. No global theme code is modified. */
(function(){
  function init(carousel){
    if(!carousel||carousel.dataset.lesimoActivewearReady==='true')return;
    carousel.dataset.lesimoActivewearReady='true';
    var track=carousel.querySelector('[data-lesimo-activewear-track]');
    var slides=Array.prototype.slice.call(carousel.querySelectorAll('[data-lesimo-activewear-slide]'));
    var dots=Array.prototype.slice.call(carousel.querySelectorAll('[data-lesimo-activewear-dot]'));
    var prev=carousel.querySelector('[data-lesimo-activewear-prev]');
    var next=carousel.querySelector('[data-lesimo-activewear-next]');
    if(!track||slides.length<2||!prev||!next)return;
    var index=0,startX=null;
    function show(newIndex){
      index=(newIndex+slides.length)%slides.length;
      track.style.transform='translate3d(-'+(index*100)+'%,0,0)';
      slides.forEach(function(slide,i){
        var isVisible=i===index;
        slide.setAttribute('aria-hidden',isVisible?'false':'true');
        slide.querySelectorAll('a,button,select,input').forEach(function(control){
          if(isVisible){control.removeAttribute('tabindex')}else{control.setAttribute('tabindex','-1')}
        });
      });
      dots.forEach(function(dot,i){dot.classList.toggle('is-active',i===index)});
    }
    prev.addEventListener('click',function(){show(index-1)});
    next.addEventListener('click',function(){show(index+1)});
    track.addEventListener('touchstart',function(event){startX=event.touches[0].clientX},{passive:true});
    track.addEventListener('touchend',function(event){
      if(startX===null)return;
      var distance=event.changedTouches[0].clientX-startX;
      if(Math.abs(distance)>45)show(index+(distance<0?1:-1));
      startX=null;
    },{passive:true});
    show(0);
  }
  function initAll(){document.querySelectorAll('[data-lesimo-activewear-carousel]').forEach(init)}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll,{once:true})}else{initAll()}
  document.addEventListener('shopify:section:load',initAll);
})();
